window.Products.Clothing.FlareSkirt = function() {
};
window.Products.Clothing.FlareSkirt.inherits(window.Products.Clothing.Clothing);

window.Products.Clothing.FlareSkirt.id = 20;
window.Products.Clothing.FlareSkirt.slug = 'flare-skirt';
window.Products.Clothing.FlareSkirt.has_3d = true;
window.Products.Clothing.FlareSkirt.dpi = 150;

window.Products.Clothing.FlareSkirt.prototype.set3dProperties = function(modelViewer) {
    this.updateThreeTexture(modelViewer);
    modelViewer.object.position.y = 0.02;
    modelViewer.object.rotation.y = 170 * Math.PI/180;
    modelViewer.camera.position.y = 0.5;
    modelViewer.camera.position.z =  1.7;
    modelViewer.initalCameraPosition.z = -1.7;
};

window.Products.Clothing.FlareSkirt.prototype.setThreeControls = function(controls) {
    controls.minDistance = 2.6;
    controls.maxDistance = 3.4;
};

window.Products.Clothing.FlareSkirt.prototype.updateThreeTexture = function(modelViewer) {
    modelViewer.object.children[0].material[0].map = modelViewer.texture;
    modelViewer.object.children[0].material[1].map = modelViewer.texture;
};